
import CustomerEditComponent from "../../../Components/CustomerEdit";
import PageHeaderMenu from "../../Auth/Menu";

function PageCustomerEdit() {
  return <PageHeaderMenu InternalComponent={<CustomerEditComponent />} />;
}

export default PageCustomerEdit;
